import React, { useState, useEffect } from 'react'
import '../../styles/create_template.css';


import { Link,useParams } from 'react-router-dom'
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import BackLoader from '../../components/backloader'

import { useNavigate } from 'react-router-dom'
import DynamicIcon from '../../components/dynamicicon'


function ViewAffidavits() {

    const {id} = useParams();
  //  const linkurl=id==null?'/templates/create':
    const tempUrl= `${Constants.apiUrl}/gazette/affidavit/${id}`;
    const [template, setTemplate]=useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [html, setHtml] =useState('');



    useEffect(() => {
        
        LoadTemplate();
    
  }, [id])

  const LoadTemplate=()=>{
    setIsLoading(true);
    fetch(tempUrl, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
            setIsLoading(false);

            if(data.code==0){

                setTemplate(data.template);
             // var htmlstr=atob(data.template.html);
             var htmlstr=Constants.b64decode(data.template.html);
              setHtml(htmlstr);
                
            }
            
        })
        .catch(error => {
            console.error(error);
            setIsLoading(false);
        })
}

  return (
    <div className='view-temp'>

        <div className="body">

            <div className="back" onClick={() => window.history.back()}>
                <Link><DynamicIcon iname="arrow_back"/> Back</Link>
            </div>

            <div className="doc">
                <h3>{template.title}</h3>
                <div className="paper-doc"> <div  className='htmlwrap' dangerouslySetInnerHTML={{__html: html}}></div></div>
                <Link to={`/templates/${template.type}/${id}/edit`}><button className='red'>Switch to edit mode</button></Link>
            </div>
        </div>
    </div>
  )
}

export default ViewAffidavits